import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { AdminApp } from './admin/AdminApp';
import './styles/globals.css';

// Ira Autopilot has two root UIs served from the same Vite bundle:
//   /admin/*  → the admin portal (plain browser, no Office.js required)
//   anything else → the Excel taskpane (runs inside Office)
// Vite's SPA fallback serves index.html for both, and we fork here.
const isAdmin = typeof window !== 'undefined'
  && window.location.pathname.startsWith('/admin');

// Office.js requires Office.onReady() to be called before any host API
// use. Historically our code awaited it from a React effect, but Office's
// handshake has a race window where the taskpane's script must call
// onReady synchronously during initial execution — otherwise you see:
//   "Office.js has not fully loaded. Your app must call Office.onReady()"
// Mount the React tree from inside the onReady callback so every Excel
// API call is guaranteed safe.
//
// Plain-browser mode (no Office on window) mounts immediately.

// Boot version stamp: the ONE-LINE answer to "is the user running the
// latest deploy?". Prod incident: the HTML shell was heuristically cached
// by the Office webview, users executed stale bundles for days after
// deploys, and every diagnosis started with guessing. The hashed bundle
// filename IS the version.
const bundleSrc = (document.querySelector('script[type="module"]') as HTMLScriptElement | null)?.src ?? 'unknown';
console.info(`[ira-autopilot] bundle: ${bundleSrc.split('/').pop()}`);

function mount() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      {isAdmin ? <AdminApp /> : <App />}
    </React.StrictMode>,
  );
}

// Admin portal is a plain browser app — Office.onReady would never
// fire, so don't wait for it. Taskpane path still gates on Office.
if (!isAdmin && typeof Office !== 'undefined' && Office?.onReady) {
  Office.onReady(() => {
    mount();
  });
} else {
  mount();
}
